import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.qnacreate');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-qnacreate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.qnacreate/view.scss */
/* src/app/component.qnacreate/view.scss: no such file or directory */`],
})
export class ComponentQnacreateComponent implements OnInit {
  public selectedFiles: File[] = [];

  constructor(@Inject( Service) public service: Service) {}

  async ngOnInit() {
    await this.service.init();
  }

  public onFileChange(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedFiles = Array.from(files);
      console.log("📂 선택된 파일:", this.selectedFiles);
    } else {
      this.selectedFiles = [];
    }
  }
}

export default ComponentQnacreateComponent;